import { alpha, styled } from "@mui/material/styles";

const ProposalAddedBadge = styled("span")(({ theme }) => ({
  backgroundColor: alpha(theme.palette.info.main, 0.1),
  border: `1px solid ${alpha(theme.palette.info.main, 0.4)}`,
  borderRadius: 999,
  color: theme.palette.info.dark,
  flexShrink: 0,
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: 1.5,
  padding: theme.spacing(0, 0.75),
  textDecoration: "none",
  whiteSpace: "nowrap",
}));

export default ProposalAddedBadge;
